import PropTypes from 'prop-types';
import { Box } from '@mui/material';
//
import Image from '../../image';

// ----------------------------------------------------------------------

AvatarPreview.propTypes = {
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  variant: PropTypes.string,
};

export default function AvatarPreview({ file, variant }) {
  if (!file) {
    return null;
  }

  const imgUrl = typeof file === 'string' ? file : file.preview;
  const borderRadius = variant === 'box' ? '10px' : '50%';
  const imageSx = {
    zIndex: 8,
    objectFit: 'cover',
    borderRadius,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  };

  if (typeof imgUrl === 'string') {
    return <Box component="img" alt="avatar" src={imgUrl} sx={imageSx} />;
  }

  return (
    <Image
      alt="avatar"
      src={imgUrl}
      sx={{
        ...imageSx,
        overflow: 'hidden',
      }}
    />
  );
}
